<template>
  <div>
    <div class="totalPie">
      <div class="tit">
        <p>巡查责任人</p>
        <span style="float:right; color: #ccc;font-size: 12px;">{{weizhi}}</span>
      </div>
      <div class="xczrr">
        <div class="zbtxk">
<!--          <img src="../../common/images/rytx.jpg" alt="" class="zbtx" />-->
        </div>
        <div class="zrrnames">
          <img src="../../common/images/fxxc.png" class="qdimg" />
          {{fxxczrrName}}
        </div>
        <div class="zrrnames1">
          <img src="../../common/images/tel.png" class="qdimg" />
          {{fxxczrrTel}}
        </div>
      </div>
    </div>
    <div class="zrrlist">
      <div class="tit">
        <p>巡查记录</p>
        <ul>
          <li v-for="(item,i) in region" :key="i" :class="regionactivelen==i?'regionactive':''"
            @click="regionClick(item,i)">{{item.name}}</li>
        </ul>
      </div>
      <div class="neirongs">
        <ul class="contents">
          <li v-for="(item,i) in xcData" :key="i">
            <div class="leftContent">
              <p>{{i+1}}</p>
              <p>{{item.ydbXjrq}}</p>
              <p></p>
              <p>巡查异常：{{item.ydbYczk}}</p>
            </div>
            <div class="rightContent">
              <p>{{weizhi}}</p>
              <p @click="jlClick(item)">详细记录</p>
              <p @click="zjClick(item)">足迹回放</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Dialog v-if="DialogVisible==true" @cancel="Cancel" :DialogData="DialogData"></Dialog>
  </div>
</template>

<script>
  import {
    ydbjbxxsearch,
    xqXunJianRecord
  } from "@/api/api.js";
  import Dialog from "./xxjlDialog.vue";
  export default {
    props: ["gisclick"],
    data() {
      return {
        weizhi: '',
        fxxczrrName: "",
        fxxczrrTel: "",
        ydbCodes: '',
        region: [{
            name: "本周",
            id: 0
          },
          {
            name: "本月",
            id: 1
          },
        ],
        regionactivelen: 0,
        xcData: [],
        DialogData: [],
        DialogVisible: false,
      };
    },
    components: {
      Dialog,
    },
    mounted() {
      if (this.$store.state.gisQueryData != null) {
        let _this = this;
        this.ydbCodes = this.$store.state.gisQueryData.ydbCode;
        let params = {
          ydbCode: this.$store.state.gisQueryData.ydbCode
        };
        ydbjbxxsearch(params).then((res) => {
          this.weizhi = res.data.ydbBaZhi;
          if (res.data.ydbXczrr) {
            _this.fxxczrrName = res.data.ydbXczrr;
            _this.fxxczrrTel = res.data.ydbXczrrlxfs;
          } else {
            _this.fxxczrrName = "xxxxxx";
            _this.fxxczrrTel = "xxxxxxxxxxx";
          }
        });
        this.xqXunJianRecordFun(params);
      }
    },
    watch: {
      gisclick(a) {
        let _this = this;
        if (a.ydbCode) {
          this.ydbCodes = a.ydbCode;
          let params = {
            ydbCode: a.ydbCode
          };
          ydbjbxxsearch(params).then((res) => {
            this.weizhi = res.data.ydbBaZhi;
            if (res.data.ydbXczrr) {
              _this.fxxczrrName = res.data.ydbXczrr;
              _this.fxxczrrTel = res.data.ydbXczrrlxfs;
            } else {
              _this.fxxczrrName = "xxxxxx";
              _this.fxxczrrTel = "xxxxxxxxxxx";
            }
          });

          this.xqXunJianRecordFun(params);
        }
      },
    },
    methods: {
      xqXunJianRecordFun(params) {
        this.xcData = [];
        xqXunJianRecord(params).then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            this.xcData = res.data;
            // this.xcData.push({
            //   time: res.data[i].ydbXjrq,
            //   content: res.data[i].ydbYczk
            // });
          }
        });
      },
      regionClick(item, i) {
        this.regionactivelen = i;
        let params1;
        if (this.regionactivelen == 1) {
          params1 = {
            ydbCode: this.ydbCodes,
            identity: 1
          };
        } else {
          params1 = {
            ydbCode: this.ydbCodes
          };
        }
        this.xqXunJianRecordFun(params1);
      },
      jlClick(item) {
        // console.log(item)
        this.DialogData = item;
        this.DialogVisible = true;
      },
      zjClick(item) {
        this.$store.state.motionData = item;
      },
      Cancel() {
        this.DialogVisible = false;
      },
    },
  };
</script>

<style scoped>
  .totalPie,
  .zrrlist {
    width: 100%;
    height: 395px;
    background: url(../../common/images/contentborder.png) no-repeat center;
    background-size: 100% 100%;
    overflow: hidden;
  }

  .zrrlist {
    margin-top: 10px;
  }

  .tit {
    padding-bottom: 5px;
    border-bottom: 1px solid #098dc7;
  }

  .totalPie ul li {
    width: 90%;
    margin-left: 5%;
    height: 45px;
    border-bottom: 1px dotted #54555c;
    cursor: pointer;
  }

  .xczrr {
    width: 90%;
    height: 220px;
    margin-left: 5%;
    margin-top: 10px;
  }

  .zbtxk {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    margin-left: 50%;
    margin-top: 50px;
    transform: translate(-50%);
    overflow: hidden;
  }

  .zbtx {
    width: 100%;
  }

  .zrrnames {
    height: 30px;
    margin-left: 50%;
    margin-top: 20px;
    transform: translate(-50%);
    color: #fff;
    font-size: 16px;
    text-align: center;
  }

  .zrrnames1 {
    height: 30px;
    margin-left: 50%;
    transform: translate(-50%);
    color: #fff;
    font-size: 16px;
    text-align: center;
  }

  .qdimg {
    position: relative;
    top: 4px;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .neirongs {
    width: 96%;
    margin-left: 2%;
    height: 340px;
    overflow: auto;
  }

  .contents {
    width: 96%;
    margin-left: 2%;
    height: 320px;
  }

  .contents li {
    width: 100%;
    height: 80px;
    margin-top: 20px;
    border: 1px solid #00B3FE;
    font-size: 14px;
    color: #fff;
    transition: all 0.2s;
    -webkit-transition: all 0.2s;
  }

  .contents li:hover {
    transform: scale(1.01);
    -ms-transform: scale(1.01);
    -moz-transform: scale(1.01);
    -webkit-transform: scale(1.01);
    -o-transform: scale(1.01);
  }

  .leftContent {
    float: left;
    width: 40%;
    height: 100%;
    margin-left: 5%;
  }

  .leftContent p:nth-child(1) {
    float: left;
    font-size: 12px;
    width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    margin-top: 12px;
    margin-right: 10px;
    border: 1px solid #00B3FE;
  }

  .leftContent p:nth-child(2) {
    float: left;
    width: 80%;
    height: 40px;
    line-height: 40px;
    text-align: left;
  }

  .leftContent p:nth-child(3) {
    float: left;
    width: 8px;
    height: 8px;
    line-height: 14px;
    margin-top: 15px;
    margin-right: 10px;
    background-color: #00B3FE;
  }

  .leftContent p:nth-child(4) {
    float: left;
    width: 80%;
    height: 40px;
    line-height: 40px;
    text-align: left;
  }

  .rightContent {
    float: left;
    width: 55%;
    height: 100%;
  }

  .rightContent p:nth-child(1) {
    float: left;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: left;
  }

  .rightContent p:nth-child(2) {
    float: left;
    width: 34%;
    height: 24px;
    line-height: 24px;
    margin-left: 8%;
    margin-right: 8%;
    margin-top: 8px;
    font-size: 12px;
    font-weight: bold;
    color: #000000;
    text-align: center;
    border-radius: 10%;
    cursor: pointer;
    background-color: #1CEA58;
  }

  .rightContent p:nth-child(2):hover {
    color: blue;
  }

  .rightContent p:nth-child(3) {
    float: left;
    width: 34%;
    height: 24px;
    line-height: 24px;
    margin-left: 8%;
    margin-right: 8%;
    margin-top: 8px;
    font-size: 12px;
    font-weight: bold;
    color: #000000;
    text-align: center;
    border-radius: 10%;
    cursor: pointer;
    background-color: #FFE557;
  }

  .rightContent p:nth-child(3):hover {
    color: blue;
  }
</style>
